/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientPermissionViewModel } from '../../models/client-permission-view-model';

export interface SaveClientPermission$Params {
  clientID: number;
      body?: ClientPermissionViewModel
}

export function SaveClientPermission(http: HttpClient, rootUrl: string, params: SaveClientPermission$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientPermissionViewModel>> {
  const rb = new RequestBuilder(rootUrl, SaveClientPermission.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientPermissionViewModel>;
    })
  );
}

SaveClientPermission.PATH = '/api/Clients/SaveClientPermission/{clientID}';
